import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from "../Components/Header";
import Loader from "../Components/loader";
import { ReactSession } from 'react-client-session';
import { useNavigate } from "react-router-dom";
ReactSession.setStoreType("localStorage");

const WhatsAppMarketing = () => {
   const navigate = useNavigate();
  const userId=ReactSession.get("welbeingId");
  const [contactsFile, setContactsFile] = useState(null);
  const [image, setImage] = useState(null);
  const [video, setVideo] = useState(null);
  const [data,setData] = useState({});
  const [getImgae,setGetImgae] = useState('');
  const [getVideo,setGetVedio] = useState ('');  
  const [loaderEndpoint, setLoaderEndpoint] = useState('');
  const [showLoader, setShowLoader] = useState(false);


  if(userId  <= 0 ){
      navigate('/login');
   }

  const getData = async() => { 
    
     try {
    const response = await axios.get('https://api.welbeing.in/admin/whatsapp/marketing/');
    // console.log(response.data);
    setData(response.data.data);
    setGetImgae(response.data.data.media[0].image);

  setGetVedio(response.data.data.media[0].video);
  } catch (error) {
    console.error("Error:", error);
  }
  }


  const handleSend = (type) => {
  let endpoint = '';
  if (type === 'image') endpoint = 'https://api.welbeing.in/admin/whatsapp/send-image/';
  if (type === 'video') endpoint = 'https://api.welbeing.in/admin/whatsapp/send-video/';
  if (type === 'text')  endpoint = 'https://api.welbeing.in/admin/whatsapp/send-text/';

  setLoaderEndpoint(endpoint);
  setShowLoader(true);
};


//   const sendImage = async() => { 
    
//      try {
//     const response = await axios.post('https://api.welbeing.in/whatsapp/send-image/');
//     console.log(response.data);

// ;
//   } catch (error) {
//     console.error("Error:", error);
//   }
//   }

//   const sendVideo = async() => { 
    
//      try {
//     const response = await axios.post('https://api.welbeing.in/whatsapp/send-video/');
//     console.log(response.data);
  
//   } catch (error) {
//     console.error("Error:", error);
//   }
//   }

//    const sendText = async() => { 
    
//      try {
//     const response = await axios.post('https://api.welbeing.in/whatsapp/send-text/');
//     console.log(response.data);
  
//   } catch (error) {
//     console.error("Error:", error);
//   }
//   }

useEffect(() => {
  getData();
}, []);




  const handleUpload = async (file, type) => {
    const formData = new FormData();
    formData.append(type, file);
    // console.log(formData)
    let endpoint = '';
    // if(!formData.file) {
    //     alert("No Files Attached");
    //     return;
    // };

    if (type === 'contacts') endpoint = 'https://api.welbeing.in/admin/whatsapp/upload-contact/';
    if (type === 'image') endpoint = 'https://api.welbeing.in/admin/whatsapp/upload-image/';
    if (type === 'video') endpoint = 'https://api.welbeing.in/admin/whatsapp/upload-video/';

    try {
      await axios.post(endpoint, formData);
      alert(`${type} uploaded successfully`);
      getData();
    } catch (err) {
      console.error(err);
      alert(`Failed to upload ${type}`);
    }
  };

//   console.log("imgae",data?.media[0].image)

  return (
    <>
       <Header/>
       {showLoader && (
     <Loader endpoint={loaderEndpoint} onComplete={() => setShowLoader(false)} />
   )}
     
   
     <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
           
           
              <div class="body-wrapper">
         <div className="container-fluid">
        <div className="card bg-light-info shadow-none position-relative overflow-hidden">
             <div className="card-body px-4 py-3">
               <div className="row align-items-center">
                 <div className="col-9">
                   <h4 className="fw-semibold mb-3">WhatsApp Marketing</h4>
                   <nav aria-label="breadcrumb">
                     <ol className="breadcrumb">
                       <li className="breadcrumb-item pb-3">
                       
                         <a href='/dashboard' className="text-muted">Dashboard</a>
                       </li>
                       <li className="breadcrumb-item active" aria-current="page">WhatsApp</li>
                     </ol>
                     <a href='/whatsapp-orders' className="btn btn-primary">WhatsApp Orders</a>
                   </nav>
                 </div>
                
                 <div className="col-3 text-center mb-n5">
                   <img src="dist/images/breadcrumb/ChatBc.png" alt="Breadcrumb" className="img-fluid mb-n4" />
   
                 </div>
               </div>
             </div>
           </div>
       <div className="container">
         <h4 className="my-5 text-center">WhatsApp Promotion</h4>
         <div className="row">
           {/* Contacts Upload */}
           <div className="col-md-4">
             <h5>Contacts</h5>
             {/* <p>Upload .csv file (columns: id, num)</p> */}
              <p>You've <b>{data?.contact?.length}</b> numbers in your contacts</p>
                           
               <p class="text-danger">Update contacts upload .csv file with first colunm as id second colunm as num</p>
            <table className="table table-sm table-bordered text-nowrap" style={{ borderColor: 'black' }}>
     <thead>
       <tr>
         <th style={{ border: '1px solid black' }}>id</th>
         <th style={{ border: '1px solid black' }}>num</th>
       </tr>
     </thead>
     <tbody>
       <tr>
         <td style={{ border: '1px solid black' }}></td>
         <td style={{ border: '1px solid black' }}>9876543210</td>
       </tr>
       <tr>
         <td style={{ border: '1px solid black' }}></td>
         <td style={{ border: '1px solid black' }}>9876543210</td>
       </tr>
     </tbody>
   </table>
   
                       
             <input type="file" accept=".csv" onChange={(e) => setContactsFile(e.target.files[0])} className="form-control mb-2" />
             <button className="btn btn-primary w-100" onClick={() => handleUpload(contactsFile, 'contacts')}>Upload Contacts</button>
             {/* <button className="btn btn-success w-100 mt-2" onClick={() => sendText()}>Send Text Message</button>*/}
             <button className="btn btn-success w-100 mt-2" onClick={() => handleSend('text')}>Send Text Message</button>
   
           </div>
   
           {/* Image Upload */}
           <div className="col-md-4">
             <h5>Image Message</h5>
             <img src={`https://api.welbeing.in/admin/whatsapp/whatsapp_data/${getImgae}`} height="200" alt="preview" className="mb-2" />
             <input type="file" accept="image/*" onChange={(e) => setImage(e.target.files[0])} className="form-control mb-2" />
             <button className="btn btn-primary w-100" onClick={() => handleUpload(image, 'image')}>Change Image</button>
             {/* <button className="btn btn-success w-100 mt-2" onClick={() => sendImage()}>Send Image Message</button> */}
             <button className="btn btn-success w-100 mt-2" onClick={() => handleSend('image')}>Send Image Message</button>
   
           </div>
   
           {/* Video Upload */}
           <div className="col-md-4">
             <h5>Video Message</h5>
             <video src={`https://api.welbeing.in/admin/whatsapp/whatsapp_data/${getVideo}`}  height="200" muted autoPlay className="mb-2" />
             <input type="file" accept="video/mp4" onChange={(e) => setVideo(e.target.files[0])} className="form-control mb-2" />
             <button className="btn btn-primary w-100" onClick={() => handleUpload(video, 'video')}>Change Video</button>
             {/* <button className="btn btn-success w-100 mt-2" onClick={() => sendVideo()}>Send Video Message</button> */}
             <button className="btn btn-success w-100 mt-2" onClick={() => handleSend('video')}>Send Video Message</button>
   
           </div>
         </div>
       </div>
       </div>
       </div>
       </div>
       </>
  );
};

export default WhatsAppMarketing;
